export default "__VITE_ASSET__DcHWEtqz__"